<template>
  <div class="" id="customerForm">
    <v-card :loading="(!fetched && !!id) || savingInProgress">
      <v-card-text>
          <v-row class="pa-0 ma-0">
            <v-col cols="12" class="pa-0 ma-0">
              <v-tabs v-model="customerFormTabsId" slider-color="accent">
              <v-tab ripple>
                <v-icon small left>$customers</v-icon>
                {{ $t("common.customer") }}
              </v-tab>
              <v-tab v-if="this.id > 0" ripple>
                <v-icon small left>$cart</v-icon>
                {{ $t("common.customer_orders") }}
              </v-tab>
              <v-tab v-if="this.id > 0" ripple id="garageTab">
                <v-icon small left>$garage</v-icon>
                {{ $t("common.garage") }}
              </v-tab>
              <v-tab v-if="this.id > 0" ripple>
                <v-icon small left>fa-dollar-sign</v-icon>
                {{ $t("common.payments") }}
              </v-tab>
              <v-tab v-if="this.id > 0" ripple>
                <v-icon small left>$calculator</v-icon>
                {{ $t("navigation.calculations") }}
              </v-tab>
              <v-tab v-if="this.id > 0" ripple>
                <v-icon small left>$mobile_phone</v-icon>
                {{ $t("navigation.calls") }}
              </v-tab>
              <v-tab v-if="this.id > 0" ripple>
                <v-icon small left>$bids</v-icon>
                {{ $t("navigation.bids") }}
              </v-tab>
              <v-tab v-if="this.id > 0" ripple>
                <v-icon small left>$document</v-icon>
                {{ $t("common.documents") }}
              </v-tab>
              </v-tabs>
            </v-col>
            <v-col class="pa-0 ma-0 text-right">
              <v-spacer></v-spacer>
              <v-btn
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  v-if="
              customer &&
              customer.id > 0 &&
              (customerFormTabsId == 0 || customerFormTabsId == 1)
            "
                  @click="remove"
                  color="red lighten-2"
                  class="mb-0 ml-3 px-0 white--text"
                  :disabled="!fetched"
                  :loading="!fetched"
                  :title="$t('common.remove')"
              >
                <v-icon small>$trash</v-icon>
              </v-btn>
              <v-btn
                  color="primary"
                  class="mb-0 ml-3 px-0 white--text"
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  v-if="
              customer &&
              customer.id > 0 &&
              (customerFormTabsId == 0 || customerFormTabsId == 1)
            "
                  @click="isVisibleMessagesWin = !isVisibleMessagesWin"
                  :disabled="!fetched"
                  :loading="!fetched"
                  :title="$t('common.messages')"
              >
                <v-icon small>fa-comment</v-icon>
              </v-btn>
              <v-btn
                  color="success"
                  class="mb-0 ml-3 px-0 white--text"
                  elevation="0"
                  min-width="36"
                  min-height="36"
                  v-if="
              customer &&
              this.id > 0 &&
              (customerFormTabsId == 0 || customerFormTabsId == 1)
            "
                  @click="goToSearchWithCustomer(customer)"
                  :disabled="!fetched"
                  :loading="!fetched"
                  :title="$t('common.creating_order')"
              >
                <v-icon small>$cart</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        <v-tabs-items v-model="customerFormTabsId">
          <v-tab-item>
            <v-card flat class="mt-5">
              <v-form ref="customerForm">
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      :value="customer.last_name"
                      v-model="customer.last_name"
                      :label="$t('common.last_name')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      :rules="[
                        (v) =>
                          !!v || $t('form.validationErrors.field_is_required'),
                      ]"
                      :value="customer.first_name"
                      v-model="customer.first_name"
                      :label="$t('common.first_name')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      :value="customer.patronymic"
                      v-model="customer.patronymic"
                      :label="$t('common.patronymic')"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      :rules="[
                        (v) =>
                          !!v || $t('form.validationErrors.field_is_required'),
                        (v) =>
                          /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/.test(
                            v
                          ) || $t('form.validationErrors.wrong_phone_number'),
                      ]"
                      :value="customer.phone"
                      v-model="customer.phone"
                      :label="$t('common.phone')"
                      :disabled="isActiveOutgoingCall"
                    >
                      <template v-if="customerId" v-slot:append>
                        <v-btn
                          icon
                          small
                          @click="makeOutgoingСall(customer.phone)"
                        >
                          <v-icon> fa-phone-square </v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      required
                      :rules="[
                        (v) => {
                          return v == null || v.length === 0
                            ? true
                            : emailValidate(v) ||
                                $t('form.validationErrors.email_not_valid');
                        },
                      ]"
                      :value="customer.email"
                      v-model="customer.email"
                      :label="$t('common.email')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      :label="$t('common.address')"
                      :value="customer.address"
                      v-model="customer.address"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      :value="customer.postal_code"
                      v-model="customer.postal_code"
                      :label="$t('common.postal_code')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-autocomplete
                      outlined
                      v-if="countries.length > 1"
                      :items="countries"
                      :label="$t('common.country')"
                      :item-text="lang === 'ru' ? 'name_ru' : 'name_en'"
                      item-value="id"
                      v-model="customer.country_id"
                      @change="
                        customer.country_id
                          ? $store.dispatch('common/citiesGet', {
                              id: customer.country_id,
                            })
                          : ''
                      "
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-autocomplete
                      outlined
                      autocomplete="off"
                      placeholder=" "
                      :disabled="!customer.country_id"
                      v-if="cities.length > 0"
                      :items="cities"
                      :label="$t('common.city')"
                      :item-text="lang === 'ru' ? 'name_ru' : 'name_en'"
                      item-value="id"
                      v-model="customer.city_id"
                      :rules="[
                        (v) =>
                          !!v || $t('form.validationErrors.field_is_required'),
                      ]"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-select
                      outlined
                      :loading="!IsFetchedCustomerTypes"
                      :items="customerTypes"
                      :label="$t('common.customer_type')"
                      item-text="name"
                      item-value="id"
                      v-model="customer.customer_type_id"
                      :rules="[
                        (v) =>
                          !!v || $t('form.validationErrors.field_is_required'),
                      ]"
                    ></v-select>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-select
                      outlined
                      v-if="customerSources.length > 0"
                      :items="customerSources"
                      :label="$t('common.customer_source')"
                      item-text="name"
                      item-value="id"
                      clearable
                      v-model="customer.customer_source_id"
                    ></v-select>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-checkbox
                      :label="$t('viewCustomers.this_is_a_company')"
                      v-model="customer.is_company"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      v-if="customer.is_company"
                      :rules="[
                        (v) =>
                          !!v || $t('form.validationErrors.field_is_required'),
                      ]"
                      :value="customer.legal_name"
                      v-model="customer.legal_name"
                      :label="$t('common.legal_name')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      v-if="customer.is_company && isVisibleRussianRequisites"
                      :value="customer.inn"
                      v-model="customer.inn"
                      :label="$t('common.inn')"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="4" class="py-0">
                    <v-text-field
                      outlined
                      v-if="customer.is_company && isVisibleRussianRequisites"
                      :value="customer.kpp"
                      v-model="customer.kpp"
                      :label="$t('viewCustomers.kpp')"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0">
                    <v-textarea
                      outlined
                      :label="$t('common.comment')"
                      :value="customer.comment"
                      v-model="customer.comment"
                    ></v-textarea>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="py-0 text-right">
                    <v-divider></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="mt-5"
                      color="primary"
                      @click="submit"
                      @keyup.enter="submit"
                      elevation="0"
                      id="saveCustomer"
                      :disabled="!fetched || savingInProgress"
                      :loading="!fetched || savingInProgress"
                    >
                      {{ $t("common.save") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="mt-5">
              <v-card-text>
                <v-data-table
                  :loading="!fetched"
                  :headers="tableOrdersHeader"
                  v-if="customer && customer.orders"
                  :items="customer.orders"
                  class="elevation-0 mb-3"
                  :footer-props="{
                    'items-per-page-text': $t('tables.items_per_page'),
                    'items-per-page-options': [
                      10, 50, 100,
                      //-1
                    ],
                  }"
                >
                  <template v-slot:footer.page-text="props">
                    {{
                      $t("tables.x_of_y", [
                        `${props.pageStart}-${props.pageStop}`,
                        props.itemsLength,
                      ])
                    }}
                  </template>
                  <template v-slot:item="props">
                    <tr class="pointer" @click="goToOrder(props.item.id)">
                      <td class="text-left">{{ props.item.human_number }}</td>
                      <td class="text-right text-no-wrap">
                        {{ formatCurrency(props.item.total_sum) }}
                      </td>
                      <td class="text-left text-no-wrap">
                        <v-chip
                            v-if="props.item.status"
                          small
                          :color="props.item.status.color"
                          :style="{
                            color: getCorrectTextColor(props.item.status.color),
                          }"
                          class="ma-2"
                          >{{
                            props.item.status_type === "system_order_status"
                              ? $t(
                                  "common.orderSystemStatusNames." +
                                    props.item.status.name
                                )
                              : props.item.status.name
                          }}
                        </v-chip>
                        <v-chip
                            v-if="props.item.status_payment"
                          small
                          :color="props.item.status_payment.color"
                          :style="{
                            color: getCorrectTextColor(
                              props.item.status_payment.color
                            ),
                          }"
                          class="ma-2"
                        >
                          {{
                            $t(
                              "common.paymentStatuses." +
                                props.item.status_payment.name
                            )
                          }}
                        </v-chip>
                      </td>
                      <td class="text-xs-left text-no-wrap">
                        {{
                          props.item.car
                            ? props.item.car.name +
                              (props.item.car.car_number
                                ? " [" +
                                  props.item.car.car_number.toUpperCase() +
                                  "] "
                                : "")
                            : "-"
                        }}
                      </td>
                      <td class="text-center text-no-wrap">
                        <v-icon
                          small
                          class="pointer mr-2"
                          @click.stop="
                            showDiagnosticWindow(
                              props.item.items.find(
                                (el) => el.idx === 'spec_diag'
                              )
                            )
                          "
                          v-if="
                            props.item.items.find(
                              (el) => el.idx === 'spec_diag'
                            )
                          "
                        >
                          fa-tasks
                        </v-icon>
                      </td>
                      <td class="text-xs-left text-no-wrap">
                        {{ props.item.created_at | moment("DD.MM.YYYY") }}
                        <br/>
                        {{ props.item.created_at | moment("HH:mm") }}
                      </td>
                    </tr>
                  </template>
                  <template v-slot:no-data>
                    {{ $t("common.no_data_available") }}
                  </template>
                  <template v-slot:no-results>
                    {{ $t("common.no_data_available") }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat class="mt-0">
              <v-card-text class="mt-0 pt-0 px-0 mx-0">
                <CustomerGarage
                  :customer-id="customerId"
                  :car-id="carId"
                  :visibility-status="customerFormTabsId == 2 && isVisible"
                  @chooseCar="
                    (car) => {
                      this.$emit('chooseCar', car);
                    }
                  "
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-data-table
                  :loading="!fetched"
                  :headers="tablePaymentsHeader"
                  v-if="customer && customer.payments"
                  :items="customer.payments"
                  class="elevation-0 mb-3"
                  :footer-props="{
                    'items-per-page-text': $t('tables.items_per_page'),
                    'items-per-page-options': [
                      50, 100,
                      //-1
                    ],
                  }"
                >
                  <template v-slot:footer.page-text="props">
                    {{
                      $t("tables.x_of_y", [
                        `${props.pageStart}-${props.pageStop}`,
                        props.itemsLength,
                      ])
                    }}
                  </template>
                  <template v-slot:item="props">
                    <tr>
                      <td class="text-xs-left text-no-wrap">
                        {{ props.item.created_at | moment("DD.MM.YYYY") }}
                        <br/>
                        {{ props.item.created_at | moment("HH:mm") }}
                      </td>
                      <td class="text-left">
                        <template
                          v-if="props.item.type === 'write_off_to_order'"
                        >
                          <span
                            @click="goToOrder(props.item.order.id)"
                            class="dashed"
                          >
                            {{ $t("payments.actions." + props.item.type) }}
                            {{ props.item.order.human_number }}/{{
                              props.item.order.created_at
                                | moment("DD.MM.YYYY HH:mm")
                            }}
                          </span>
                        </template>
                        <template v-else>
                          {{ $t("payments.actions." + props.item.type) }}
                        </template>
                      </td>
                      <td class="text-left text-no-wrap">{{ formatCurrency(props.item.value) }} </td>
                    </tr>
                  </template>
                  <template v-slot:no-data>
                    {{ $t("common.no_data_available") }}
                  </template>
                  <template v-slot:no-results>
                    {{ $t("common.no_data_available") }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item>

            <v-data-table
              :loading="!fetched"
              :headers="tableCalculationsHeader"
              :items="customer.calculations"
              class="elevation-0 mb-3 tableCalculations"
              @click:row="tableCalculationsRowClick"
              :footer-props="{
                'items-per-page-text': $t('tables.items_per_page'),
                'items-per-page-options': [
                  50, 100,
                  //-1
                ],
              }"
            >
              <template v-slot:footer.page-text="props">
                {{
                  $t("tables.x_of_y", [
                    `${props.pageStart}-${props.pageStop}`,
                    props.itemsLength,
                  ])
                }}
              </template>
              <template v-slot:item.total_sum="props">
                {{ formatCurrency(props.item.total_sum) }}
              </template>
              <template v-slot:item.created_at="props">
                {{ props.item.created_at | moment("DD.MM.YYYY") }}
                <br/>
                {{ props.item.created_at | moment("HH:mm") }}
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
              :loading="!fetched"
              :headers="tableCallsHeader"
              :items="customer.calls"
              class="elevation-0 mb-3 tableCalculations"
              :footer-props="{
                'items-per-page-text': $t('tables.items_per_page'),
                'items-per-page-options': [
                  50, 100,
                  //-1
                ],
              }"
            >
              <template v-slot:footer.page-text="props">
                {{
                  $t("tables.x_of_y", [
                    `${props.pageStart}-${props.pageStop}`,
                    props.itemsLength,
                  ])
                }}
              </template>
              <template v-slot:item="props">
                <tr>
                  <td class="text-xs-left">
                    {{ props.item.created_at | moment("DD.MM.YYYY") }}
                    <br/>
                    {{ props.item.created_at | moment("HH:mm") }}
                  </td>
                  <td class="text-xs-left">
                    <span v-if="props.item.call_direction">
                      <v-icon
                        v-if="props.item.call_direction === 1"
                        color="success"
                      >
                        mdi-call-received
                      </v-icon>
                      <v-icon
                        v-if="props.item.call_direction === 2"
                        color="danger"
                      >
                        mdi-call-made
                      </v-icon>
                      <v-icon v-if="props.item.call_direction === 0">
                        mdi-swap-vertical-variant
                      </v-icon>
                    </span>
                    {{ props.item.phone }}
                  </td>
                  <td class="text-xs-left">{{ props.item.length_sec }}</td>
                  <td
                    class="text-right text-no-wrap vertical_align_center"
                    style="min-width: 280px"
                  >
                    <div
                      class="d-inline-block callRecPlayer"
                      v-if="
                        !!records.find(
                          (rec) =>
                            rec.callId === props.item.id &&
                            rec.isFetching === false
                        )
                      "
                    >
                      <vue-plyr
                        :key="props.item.recording_id"
                        :download="
                          records.find(
                            (rec) => rec.callId === props.item.id && rec.file
                          ).file
                        "
                        v-if="
                          props.item.recording_id &&
                          records.find(
                            (rec) =>
                              rec.callId === props.item.id &&
                              rec.file &&
                              !rec.isFetching
                          )
                        "
                      >
                        <audio controls crossorigin playsinline>
                          <source
                            :src="
                              records.find(
                                (rec) =>
                                  rec.callId === props.item.id && rec.file
                              ).file
                            "
                            type="audio/mp3"
                          />
                        </audio>
                      </vue-plyr>
                    </div>
                  </td>
                  <td class="text-right text-no-wrap" style="min-width: 80px">
                    <v-btn
                      elevation="0"
                      min-width="36"
                      min-height="36"
                      color="green"
                      class="mb-0 ml-3 px-0 white--text"
                      @click="getCallRecord(props.item)"
                      :loading="
                        !!records.find(
                          (rec) =>
                            rec.callId === props.item.id && rec.isFetching
                        )
                      "
                      :disabled="
                        !props.item.recording_id ||
                        !!records.find(
                          (rec) =>
                            rec.callId === props.item.id && rec.isFetching
                        )
                      "
                    >
                      <v-icon small>mdi-headphones</v-icon>
                    </v-btn>
                    <!--              <v-btn-->
                    <!--                  elevation="0"-->
                    <!--                  min-width="36"-->
                    <!--                  min-height="36"-->
                    <!--                  @click="$store.dispatch('calls/remove', { id: props.item.id })"-->
                    <!--                  color="red lighten-2"-->
                    <!--                  class="mb-0 ml-3 px-0 white&#45;&#45;text"-->
                    <!--                  :title="$t('common.remove')"-->
                    <!--              >-->
                    <!--                <v-icon small>$trash</v-icon>-->
                    <!--              </v-btn>-->
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <v-data-table
              :loading="!fetched"
              :headers="tableBidsHeader"
              :items="customer.bids"
              class="elevation-0 mb-3 tableCalculations"
              :footer-props="{
                'items-per-page-text': $t('tables.items_per_page'),
                'items-per-page-options': [
                  50, 100,
                  //-1
                ],
              }"
            >
              <template v-slot:footer.page-text="props">
                {{
                  $t("tables.x_of_y", [
                    `${props.pageStart}-${props.pageStop}`,
                    props.itemsLength,
                  ])
                }}
              </template>
              <template v-slot:item.created_at="props">
                {{ props.item.created_at | moment("DD.MM.YYYY") }}
                <br/>
                {{ props.item.created_at | moment("HH:mm") }}
              </template>
              <template v-slot:item.phone="props">
                <span v-if="props.item.customer">
                  {{ props.item.customer.phone }}
                </span>
                <span v-else>
                  {{ props.item.customer_phone }}
                </span>
              </template>
              <template v-slot:item.desired_date="props">
                {{ props.item.desired_date | moment("DD.MM.YYYY") }}
                <br/>
                {{ props.item.desired_date | moment("HH:mm") }}
              </template>
              <template v-slot:item.comment="props">
                {{ props.item.comment }}
              </template>
              <template v-slot:item.operations="props">
                <div v-for="operation in props.item.operations">
                  {{ getOperationName(operation, lang) }}
                </div>
              </template>
              <template v-slot:item.car="props">
                <span v-if="props.item.car">
                  <span>
                    {{ props.item.car.name }}
                  </span>
                  <beauty-car-number
                    v-if="props.item.car && props.item.car.car_number"
                    :number="props.item.car.car_number"
                  ></beauty-car-number>
                </span>
                <span v-else>
                  {{ props.item.brand }} {{ props.item.model }}
                  <beauty-car-number
                    v-if="props.item.car_number"
                    :number="props.item.car_number"
                  ></beauty-car-number>
                </span>
              </template>
              <template v-slot:item.vin="props">
                {{ props.item.vin }}
              </template>
              <template v-slot:item.url="props">
                <v-btn
                  fab
                  small
                  text
                  v-if="props.item.url"
                  :href="props.item.url"
                  :title="props.item.url"
                  target="_blank"
                  :disabled="!fetched"
                  ><v-icon small>fa-link</v-icon></v-btn
                >
                <v-chip small v-for="utm in props.item.utm" class="ma-1">
                  {{ utm.key }}: {{ utm.value }}
                </v-chip>
              </template>
              <template v-slot:item.stage="props">
                <bid-stage-select
                  :bid-stages="bidStages"
                  :stage="props.item.stage"
                  :loading="
                    nowProcessingBidWithId === props.item.id ||
                    !bidsStagesIsFetched
                  "
                  @update="
                    (st) => {
                      props.item.stage = st;
                      props.item.bid_stage_id = st.id;
                      updateBid(props.item);
                    }
                  "
                ></bid-stage-select>
              </template>
              <template v-slot:item.actions="props">
                <div class="text-right" style="min-width: 100px">
                  <span class="btn-td-wrap">
                    <v-btn
                      elevation="0"
                      min-width="36"
                      min-height="36"
                      color="primary"
                      class="mb-0 ml-3 px-0 white--text"
                      :title="$t('common.edit')"
                      :disabled="!fetched"
                      @click="
                        activeBid = props.item;
                        bidWindow = true;
                        activeBid.customer = customer
                      "
                    >
                      <v-icon small>$pencil</v-icon>
                    </v-btn>
                    <v-btn
                      elevation="0"
                      min-width="36"
                      min-height="36"
                      class="mb-0 ml-3 px-0 white--text"
                      :color="!props.item.order ? 'success' : 'blue'"
                      :title="
                        !props.item.order
                          ? $t('common.creating_order')
                          : $t('common.go_to_order')
                      "
                      :disabled="!fetched"
                      @click="handleClickOrderForBid(props.item)"
                    >
                      <v-icon small>$cart</v-icon>
                    </v-btn>
                  </span>
                </div>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
          </v-tab-item>
          <v-tab-item>
            <customer-documents-table :customer-id="id" v-if="id"/>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
    <order-window
        :is-visible="orderWindow.isVisible"
        :order-id="orderWindow.orderId"
        @hide="()=>{orderWindow.orderId=null; orderWindow.isVisible=false;}"
    />
    <diagnostic-window
      :show="orderItemDiagnosticWindow.isVisible"
      :item="orderItemDiagnosticWindow.item"
      @hide="orderItemDiagnosticWindow.isVisible = false"
    ></diagnostic-window>
    <customer-messages-window
      :show="isVisibleMessagesWin"
      :customer="customer"
      @hide="isVisibleMessagesWin = false"
    />
    <bid-window
      :show="bidWindow"
      :bid-id="activeBid && activeBid.id"
      :customer="activeBid && activeBid.customer"
      @hide="
        bidWindow = false;
        activeBid = null;
      "
      @update="
        (bid) => {
          activeBid = null;
        }
      "
    />
  </div>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import CommonMixin from "@/mixins/common";
import DiagnosticWindow from "@/components/order/DiagnosticWindow";
import CustomerMessagesWindow from "@/components/customer/CustomerMessagesWindow";
import BeautyCarNumber from "@/components/common/BeautyCarNumber";
import BidStageSelect from "@/components/bid/BidStageSelect";
import BidWindow from "@/components/bid/BidWindow";
import CustomerDocumentsTable from "@/components/customer/CustomerDocumentsTable";
import BidsMixin from "@/mixins/bids";
//import OrderWindow from "@/components/order/OrderWindow.vue";

export default {
  name: "customerForm",
  props: {
    isVisible: Boolean,
    customerId: Number,
    carId: Number,
    newCustomerPhoneNumber: {
      type: String,
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [CommonMixin, BidsMixin],
  components: {
    OrderWindow: () => import("@/components/order/OrderWindow.vue"),
    CustomerDocumentsTable,
    BidWindow,
    BidStageSelect,
    BeautyCarNumber,
    CustomerMessagesWindow,
    DiagnosticWindow,
    CustomerGarage: () => import("@/components/customer/CustomerGarage.vue"),
  },
  data: () => ({
    id: null,
    isVisibleMessagesWin: null,
    orderItemDiagnosticWindow: {
      isVisible: false,
      item: null,
    },
    bidWindow: false,
    activeBid: null,
    customer: {
      customer_type_id: null,
    },
    orderWindow: {
      orderId: null,
      isVisible: false
    }
  }),
  mounted() {
    this.onLoad();
  },
  watch: {
    customerId(to, from) {
      this.id = null;
      if (to) {
        this.onLoad();
      }
    },
    async isVisible(isVisible) {
      if (!isVisible) return;
      if (this.$refs["customerForm"]) this.$refs["customerForm"].reset();
      if(this.customerId) {
        this.customer = await this.$store.dispatch('customers/getOne', {id: this.customerId});
      }
      this.customerEditFormTab = 0;
      this.onLoad();
    },
  },
  computed: {
    ...mapFields("auth", ["authenticatedUser"]),
    ...mapFields("site", ["lang"]),
    ...mapFields("telephonies", ["isActiveOutgoingCall"]),
    ...mapFields("common", ["countries", "cities"]),
    ...mapFields("customer_types", ["customerTypes"]),
    ...mapFields("customer_types", { IsFetchedCustomerTypes: "fetched" }),
    ...mapFields("customer_sources", ["customerSources"]),
    ...mapFields("customers", [
      "fetched",
      "savingInProgress",
      "customerFormTabsId",
    ]),
    ...mapFields("bid_stages", ["bidStages"]),
    ...mapFields("bid_stages", { bidsStagesIsFetched: "fetched" }),
    ...mapFields("bids", ["nowProcessingBidWithId"]),
    isVisibleRussianRequisites() {
      return this.lang === "ru";
    },
    tableOrdersHeader() {
      return [
        {
          text: this.$t("viewOrders.tableHeader.human_number"),
          value: "human_number",
          sortable: true,
        },
        {
          text: this.$t("viewOrders.tableHeader.total_sum"),
          value: "total_sum",
          sortable: true,
          class: "text-no-wrap",
          align: "right",
        },
        { text: this.$t("common.status"), value: "status", sortable: true },
        { text: this.$t("common.car"), value: "car", sortable: true },
        { text: this.$t("viewOrders.tableHeader.diagnostic"), sortable: false },
        {
          text: this.$t("viewOrders.tableHeader.created_at"),
          value: "created_at",
          sortable: true,
        },
      ];
    },
    tablePaymentsHeader() {
      return [
        {
          text: this.$t("viewOrders.tableHeader.created_at"),
          value: "created_at",
          sortable: true,
        },
        {
          text: this.$t("payments.type"),
          value: "type",
          sortable: true,
          align: "start",
        },
        { text: this.$t("common.total_sum"), value: "status", sortable: true },
      ];
    },
    tableCalculationsHeader() {
      return [
        {
          text: this.$t("viewOrders.tableHeader.human_number"),
          value: "id",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.title"),
          value: "name",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.total_sum"),
          value: "total_sum",
          sortable: true,
          align: "left",
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewOrders.tableHeader.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
      ];
    },
    tableBidsHeader() {
      return [
        {
          text: this.$t("common.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },

        {
          text: this.$t("viewBids.desired_date"),
          value: "desired_date",
          sortable: true,
          class: "text-no-wrap",
        },

        {
          text: this.$t("common.repairtimes"),
          value: "operations",
          sortable: false,
        },
        {
          text: this.$t("common.car"),
          value: "car",
          sortable: false,
        },
        {
          text: this.$t("viewBids.url"),
          value: "url",
          sortable: true,
          class: " text-no-wrap",
        },
        {
          text: this.$t("viewBids.bid_status"),
          sortable: false,
          class: "text-no-wrap",
          value: "stage",
        },
        {
          text: "",
          sortable: false,
          class: "text-no-wrap flex-nowrap justify-space-between",
          is_action_column: true,
          value: "actions",
        },
      ];
    },
    tableCallsHeader() {
      return [
        {
          text: this.$t("common.created_at"),
          value: "created_at",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.phone"),
          value: "phone",
          sortable: true,
          class: "text-no-wrap",
        },
        {
          text: this.$t("viewCalls.length_sec"),
          value: "length_sec",
          sortable: true,
          class: "text-no-wrap",
        },
        { text: "", sortable: false, class: "text-no-wrap" },
      ];
    },
    ...mapFields("calls", ["calls", "isCallRecordFetching", "records"]),
  },
  methods: {
    async handleClickOrderForBid(bid) {
      if (bid.order && bid.order.id) {
        this.orderWindow.isVisible = true;
        this.orderWindow.orderId = bid.order.id;
        return;
      }

      if (parseInt(bid.customer_car_id) > 0) {
        this.goToSearchWithCustomerCar(bid.car, null, bid.id);
        return;
      }
      if (parseInt(bid.customer_id) > 0) {
        this.goToSearchWithCustomer(this.customer, bid.id);
        return;
      }
    },
    updateBid(bid) {
      this.$store.dispatch("bids/update", bid).then((res) => {});
    },
    getOperationName(operation, lang) {
      let name = operation.text && operation.text[lang];
      if (name) return name;
      if (lang === "en") return operation.name_en;
      if (lang === "ru") return operation.name_ru;
      if (operation.title) return operation.title;
      return "Unknown operation";
    },
    getCallRecord(call) {
      this.$store.dispatch("calls/getCallRecord", call);
    },
    tableCalculationsRowClick(item) {
      this.$router.push({ name: "calculations", params: { id: item.id } });
    },
    goToOrder(id) {
      this.orderWindow.orderId = id;
      this.orderWindow.isVisible = true;
      // this.$router.push({
      //   name: "orders",
      //   params: { id: id },
      // });
    },
    showDiagnosticWindow(item) {
      this.orderItemDiagnosticWindow.item = item;
      this.orderItemDiagnosticWindow.isVisible = true;
    },
    setDefaultCustomerType() {
      if (this.customerTypes && this.customerTypes[0].id && !this.customerId) {
        this.customer.customer_type_id = this.customerTypes[0].id;
      }
    },
    makeOutgoingСall(phone) {
      this.$store.dispatch("telephonies/outgoingСall", {
        hash: this.authenticatedUser.hash,
        phone,
      });
    },
    async onLoad() {
      this.$store.dispatch("bid_stages/get");
      this.$store.dispatch("customer_sources/get");
      this.$store.dispatch("customer_types/get").then(() => {
        this.setDefaultCustomerType();
      });
      if (this.customerId > 0) {
        this.id = this.customerId;
        this.customer = await this.$store.dispatch('customers/getOne', {id: this.customerId});
        if (this.customer === null) {
          //this.$router.push({ name: "404" });
        } else {
          this.$store.dispatch("common/countriesGet").then(() => {
            if (this.customer.country_id) {
              this.$store.dispatch("common/citiesGet", {
                id: this.customer.country_id,
              });
            }
          });
        }
      } else {
        this.customer = {};
        this.fetched = true;
        this.id = null;
      }
      if (! this.id ){
        this.$store.dispatch("common/countriesGet");
        this.$store.dispatch("customers/customerNew").then(() => {
          if (this.newCustomerPhoneNumber) {
            this.customer.phone = this.newCustomerPhoneNumber;
          }
        });
      }
    },
    submit() {
      if (this.$refs["customerForm"].validate()) {
        if (this.id) {
          this.$store
            .dispatch("customers/update", { id: this.id })
            .then((data) => {
              this.$emit("update", data);
              //this.$refs['customerForm'].reset()
            });
        } else {
          this.$store.dispatch("customers/store", this.customer).then((data) => {
            if (data.id > 0) {
              this.$emit("store", data);
              this.$refs["customerForm"].reset();
            }
          });
        }
      }
    },
    remove() {
      this.$store
        .dispatch("customers/remove", {
          id: this.customer.id,
        })
        .then((result) => {
          if (result) {
            this.$emit("removed");
          }
        });
    },
    emailValidate(v) {
      return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      );
    },
  },
};
</script>